import _ from "lodash";
import { Area } from "react-easy-crop";

function hasAudio(video: HTMLVideoElement): boolean {
  return (
    (video as any).mozHasAudio ||
    Boolean((video as any).webkitAudioDecodedByteCount) ||
    Boolean((video as any).audioTracks?.length)
  );
}

async function checkVideoHasAudioUsingWebAudio(
  arrayBuffer: ArrayBuffer,
): Promise<boolean> {
  let audioContext: AudioContext | null = null;

  try {
    const AudioContext =
      window.AudioContext || (window as any).webkitAudioContext;
    audioContext = new AudioContext();
    const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
    return audioBuffer.numberOfChannels > 0;
  } catch (e) {
    console.log("Error checking audio:", e);
    return false;
  }
}

export const getVideoDimensions = (
  file: File,
): Promise<{ width: number; height: number; hasAudio: boolean }> => {
  return new Promise((resolve, reject) => {
    const type = file.type.split("/")[0];
    if (type !== "video") reject("Invalid file type");
    const video = document.createElement("video");
    video.preload = "metadata";
    video.onloadedmetadata = async () => {
      const audio = await checkVideoHasAudioUsingWebAudio(
        await file.arrayBuffer(),
      );

      resolve({
        width: video.videoWidth,
        height: video.videoHeight,
        hasAudio: audio,
      });
    };
    video.onerror = reject;
    video.src = URL.createObjectURL(file);
  });
};

function isEven(n: number) {
  return n % 2 == 0;
}

export const processCropArea = (
  cropArea: Area,
  videoDimensions: { width: number; height: number },
) => {
  var xl: number, xr: number, yt: number, yb: number;

  xl = cropArea.x;
  xr = videoDimensions.width - (cropArea.x + cropArea.width);

  yt = cropArea.y;
  yb = videoDimensions.height - (cropArea.y + cropArea.height);

  if (!isEven(xl)) xl = xl - 1;
  if (!isEven(xr)) xr = xr - 1;
  if (!isEven(yt)) yt = yt - 1;
  if (!isEven(yb)) yb = yb - 1;

  return { xl, xr, yt, yb };
};
